import { Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

export const RoleRoute = ({ allow, children }) => {
    const { user } = useApp();
    if (!user) return <Navigate to="/login" replace />;
    if (allow && !allow.includes(user.role)) {
        return (
            <Navigate
                to={user.role === "vigilante" ? "/vigilante" : "/dashboard"}
                replace
            />
        );
    }
    return children;
};

export const RoleSwitch = ({ vigilante, sindico }) => {
    const { user } = useApp();
    if (!user) return <Navigate to="/login" replace />;
    return user.role === "vigilante" ? vigilante : sindico;
};
